import React, { useState } from 'react';
import { ChevronDown, ChevronUp, Clock, AlertTriangle, ShieldCheck, ShoppingBag } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function FAQ() {
  const [openIndex, setOpenIndex] = useState(null);
  const toggleQuestion = index => {
    setOpenIndex(openIndex === index ? null : index);
  };
  const faqs = [{
    question: '¿Qué es RelaxGlow y para qué sirve?',
    answer: <>
          RelaxGlow es un gorro terapéutico diseñado específicamente para
          aliviar migrañas y dolores de cabeza de forma natural.
          <br data-id="element-136" />
          <br data-id="element-137" />
          Utiliza principios de termoterapia (frío y calor) para reducir la
          inflamación, relajar los músculos tensos y calmar el sistema nervioso
          sobrecargado.
          <br data-id="element-138" />
          <br data-id="element-139" />
          Es una solución no farmacológica que ayuda a miles de personas a
          reducir la frecuencia e intensidad de sus dolores de cabeza.
        </>
  }, {
    question: '¿Cómo se usa correctamente?',
    answer: <>
          Es muy sencillo de usar:
          <br data-id="element-140" />
          <br data-id="element-141" />
          <strong data-id="element-142">Para terapia fría:</strong> Colócalo en el refrigerador (no
          congelador) por 1-2 horas. Úsalo durante 10-15 minutos.
          <br data-id="element-143" />
          <br data-id="element-144" />
          <strong data-id="element-145">Para terapia caliente:</strong> Caliéntalo en microondas por
          30 segundos (verificando que no esté demasiado caliente). Úsalo hasta
          10 minutos.
          <br data-id="element-146" />
          <br data-id="element-147" />
          Ajusta el tiempo según tu tolerancia y necesidad. Para mejores
          resultados, úsalo cuando sientas que comienza el dolor o durante un
          episodio activo.
        </>
  }, {
    question: '¿Cuánto tiempo tarda en hacer efecto?',
    answer: <>
          La mayoría de usuarios reporta sentir alivio en los primeros 5-10
          minutos de uso.
          <br data-id="element-148" />
          <br data-id="element-149" />
          Para dolores más intensos, se recomienda usarlo durante 15 minutos y
          repetir después de una pausa si es necesario.
          <br data-id="element-150" />
          <br data-id="element-151" />
          Con uso regular, muchos usuarios notan una reducción en la frecuencia
          de sus migrañas después de 2-3 semanas.
        </>
  }, {
    question: '¿Es adecuado para todo tipo de dolores de cabeza?',
    answer: <>
          RelaxGlow es efectivo para diversos tipos de dolores de cabeza,
          incluyendo:
          <br data-id="element-152" />
          <br data-id="element-153" />
          <ul className="list-disc pl-6 space-y-2" data-id="element-154">
            <li data-id="element-155">Migrañas</li>
            <li data-id="element-156">Cefaleas tensionales</li>
            <li data-id="element-157">Dolores cervicogénicos (originados en el cuello)</li>
            <li data-id="element-158">Dolores por estrés</li>
            <li data-id="element-159">Cefaleas por uso excesivo de dispositivos electrónicos</li>
          </ul>
          <br data-id="element-160" />
          Si sufres de dolores de cabeza severos o crónicos, te recomendamos
          consultar con tu médico para un diagnóstico adecuado.
        </>
  }, {
    question: '¿Cuánto dura el producto?',
    answer: <>
          Con el cuidado adecuado, tu RelaxGlow durará más de 12 meses
          manteniendo todas sus propiedades terapéuticas.
          <br data-id="element-161" />
          <br data-id="element-162" />
          Incluimos instrucciones detalladas de cuidado con cada producto para
          maximizar su vida útil.
          <br data-id="element-163" />
          <br data-id="element-164" />
          El material de alta calidad está diseñado para soportar múltiples
          ciclos de calentamiento y enfriamiento sin degradarse.
        </>
  }, {
    question: '¿Qué garantía tengo al comprarlo?',
    answer: <>
          30 días para probarlo.
          <br data-id="element-165" />
          <br data-id="element-166" />
          Si no sientes un cambio… te devolvemos el dinero. Sin preguntas. Sin
          letras pequeñas.
          <br data-id="element-167" />
          <br data-id="element-168" />
          Porque <em data-id="element-169">creemos más en tu alivio que en una venta rápida</em>.
        </>
  }, {
    question: '¿El pago es seguro y qué métodos de pago tienen?',
    answer: <>
          Sí. Tu compra está protegida con plataformas de pago 100% seguras como
          N1CO y WOMPI si deseas pagar con tarjeta.
          <br data-id="element-170" />
          <br data-id="element-171" />
          También tenemos PAGO CONTRA ENTREGA EN TODO EL SALVADOR
          <br data-id="element-172" />
          <br data-id="element-173" />
          Además, puedes pagar por transferencia bancaria BAC CREDOMATIC a
          cuenta jurídica a nombre de SHOPYSV. Nuestro número de cuenta es:
          201502648
          <br data-id="element-174" />
          <br data-id="element-175" />
          Tomas una captura de pantalla y la envías a nuestro número de
          WhatsApp: 7666-8786
          <br data-id="element-176" />
          <br data-id="element-177" />
          Correo: contacto@shopysv.com
        </>
  }, {
    question: '¿Tendré que pagar algo extra al recibirlo?',
    answer: <>
          No. El precio que ves publicado ya incluye el producto, accesorios y
          envío gratis.
          <br data-id="element-178" />
          <br data-id="element-179" />
          No tendrás cargos ocultos ni sorpresas al recibirlo.
        </>
  }, {
    question: '¿Cómo sé que no me van a estafar?',
    answer: <>
          Somos una tienda verificada online y física ubicada en Condominios
          Cuscatlán, local 203 y 216, San Salvador 🛡️
          <br data-id="element-180" />
          <br data-id="element-181" />
          Además, trabajamos con procesadores de pago reconocidos y ofrecemos
          envío con empresas de mensajería confiables
          <br data-id="element-182" />
          <br data-id="element-183" />
          Recibirás confirmación y número de rastreo al realizar tu compra.
        </>
  }, {
    question: '¿Qué beneficios tengo comprando ahora y no después?',
    answer: <>
          ✅ Al comprar ahora aseguras:
          <br data-id="element-184" />
          <br data-id="element-185" />
          <ul className="list-disc pl-6 space-y-2" data-id="element-186">
            <li data-id="element-187">Precio promocional activo (puede subir en próximos días).</li>
            <li data-id="element-188">Stock disponible inmediato (la demanda es muy alta).</li>
            <li data-id="element-189">
              Envío prioritario, para que lo recibas antes que otros
              compradores.
            </li>
          </ul>
        </>
  }];
  return <section id="faq" className="py-10 bg-white" data-id="element-190">
      <div className="container mx-auto px-4" data-id="element-191">
        <div className="max-w-4xl mx-auto" data-id="element-192">
          <motion.div className="text-center mb-12" initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-193">
            <h2 className="text-3xl md:text-4xl font-bold mb-6 text-center text-gray-800" data-id="element-194">
              Preguntas Frecuentes
            </h2>
            <p className="text-gray-600" data-id="element-195">
              Todo lo que necesitas saber antes de tomar tu decisión
            </p>
          </motion.div>
          <motion.div className="bg-yellow-50 p-4 rounded-lg mb-8 border-l-4 border-yellow-500 flex items-start" initial={{
          opacity: 0,
          x: -20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} data-id="element-196">
            <Clock size={24} className="text-yellow-600 mr-3 mt-1 flex-shrink-0" data-id="element-197" />
            <div data-id="element-198">
              <h3 className="font-bold text-lg mb-1 text-yellow-800" data-id="element-199">
                ¡No pierdas más tiempo sufriendo!
              </h3>
              <p className="text-yellow-700" data-id="element-200">
                La mayoría de nuestros clientes lamenta no haber descubierto
                RelaxGlow antes. Cada día con dolor es un día perdido de tu
                vida.
              </p>
            </div>
          </motion.div>
          <div className="space-y-4" data-id="element-201">
            {faqs.map((faq, index) => <motion.div key={index} className="border border-gray-200 rounded-lg overflow-hidden shadow-sm" initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.4,
            delay: 0.1 * index
          }} whileHover={{
            boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)'
          }} data-id="element-202">
                <motion.button className="w-full flex justify-between items-center p-5 bg-blue-50 hover:bg-blue-100 transition-colors text-left font-semibold text-gray-800" onClick={() => toggleQuestion(index)} whileTap={{
              scale: 0.98
            }} data-id="element-203">
                  <span data-id="element-204">
                    🔹 {index + 1}. {faq.question}
                  </span>
                  {openIndex === index ? <ChevronUp className="text-blue-600 flex-shrink-0" data-id="element-205" /> : <ChevronDown className="text-blue-600 flex-shrink-0" data-id="element-206" />}
                </motion.button>
                <AnimatePresence data-id="element-207">
                  {openIndex === index && <motion.div className="p-5 bg-white" initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} data-id="element-208">
                      <div className="text-gray-700 leading-relaxed" data-id="element-209">
                        {faq.answer}
                      </div>
                      {index === 9 && <motion.div className="mt-4 bg-red-50 p-3 rounded-lg border-l-4 border-red-500 flex items-start" animate={{
                  scale: [1, 1.03, 1]
                }} transition={{
                  repeat: Infinity,
                  duration: 2
                }} data-id="element-210">
                          <AlertTriangle size={20} className="text-red-500 mr-2 mt-1 flex-shrink-0" data-id="element-211" />
                          <p className="text-red-700 text-sm" data-id="element-212">
                            <strong data-id="element-213">¡Advertencia!</strong> El precio promocional
                            y el inventario disponible pueden cambiar en
                            cualquier momento sin previo aviso.
                          </p>
                        </motion.div>}
                      {index === 5 && <motion.div className="mt-4 bg-green-50 p-3 rounded-lg border-l-4 border-green-500 flex items-start" animate={{
                  scale: [1, 1.03, 1]
                }} transition={{
                  repeat: Infinity,
                  duration: 2
                }} data-id="element-214">
                          <ShieldCheck size={20} className="text-green-500 mr-2 mt-1 flex-shrink-0" data-id="element-215" />
                          <p className="text-green-700 text-sm" data-id="element-216">
                            <strong data-id="element-217">100% Garantizado</strong> - Pruébalo por 30
                            días sin riesgo. Si no estás satisfecho, te
                            devolvemos tu dinero.
                          </p>
                        </motion.div>}
                    </motion.div>}
                </AnimatePresence>
              </motion.div>)}
          </div>
          <motion.div className="mt-12 text-center" initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          duration: 0.6,
          delay: 0.8
        }} data-id="element-218">
            <motion.a href="https://shopysv.com/products/pide-tu-gorro-anti-migrana" className="bg-blue-600 text-white px-8 py-4 rounded-full text-lg font-semibold hover:bg-blue-700 transition-colors inline-flex items-center" whileHover={{
            scale: 1.05
          }} whileTap={{
            scale: 0.95
          }} data-id="element-219">
              <span data-id="element-220">Quiero mi RelaxGlow ahora</span>
              <motion.div animate={{
              x: [0, 5, 0]
            }} transition={{
              repeat: Infinity,
              duration: 1.5
            }} className="ml-2" data-id="element-221">
                <ShoppingBag size={18} data-id="element-222" />
              </motion.div>
            </motion.a>
            <p className="mt-4 text-gray-600" data-id="element-223">
              Garantía de devolución de 30 días. Sin riesgos.
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}